import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import PayrollManagementPage from './PayrollManagementPage'
import { PayrollMobileView } from './PayrollMobileView'

export const PayrollPage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // Render mobile view for mobile devices
  if (isMobile) {
    return <PayrollMobileView />
  }

  return <PayrollManagementPage />
}
